export default theme => ({
  banner_container: {
    flexGrow: 1,
    padding: theme.spacing(3),
    height: "100%",
    overflow: "auto",
    backgroundColor: theme.palette.warning.main,
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(3),
    borderRadius: 3,
    [theme.breakpoints.down("md")]: {
      flexDirection: "column",
    },
  },
  banner: {
    display: 'flex',
    flexDirection: "column",
    [theme.breakpoints.down("md")]: {
      gap: theme.spacing(3),
    },
  }
});
